"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var TextField_1 = require("@material-ui/core/TextField");
var GenericInputStyles_1 = require("./GenericInputStyles");
var core_1 = require("@material-ui/core");
var DateRange_1 = require("@material-ui/icons/DateRange");
var Translation_1 = require("../../../common/components/presentation/Translation/Translation");
var GenericInputLabel_1 = require("./GenericInputLabel");
var clsx_1 = require("clsx");
exports.GenericInput = function (_a) {
    var label = _a.label, required = _a.required, id = _a.id, onChange = _a.onChange, value = _a.value, currentError = _a.currentError, inputLabel = _a.inputLabel, type = _a.type, datePicker = _a.datePicker, toggleDatePicker = _a.toggleDatePicker, phoneWithPrefix = _a.phoneWithPrefix, params = _a.params, tooltip = _a.tooltip, placeholder = _a.placeholder, startAdornment = _a.startAdornment, classes = _a.classes;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var styles = GenericInputStyles_1.default();
    var checkoutLite = core_1.useTheme().checkoutLite;
    var showRequiredInPlaceholder = (_c = (_b = checkoutLite) === null || _b === void 0 ? void 0 : _b.enquiryForm) === null || _c === void 0 ? void 0 : _c.showRequiredInPlaceholder;
    var displayRequiredInPlaceholder = showRequiredInPlaceholder !== undefined ? showRequiredInPlaceholder && required : required;
    return (<div ref={(_e = (_d = params) === null || _d === void 0 ? void 0 : _d.InputProps) === null || _e === void 0 ? void 0 : _e.ref} className={clsx_1.default([styles.fieldWrapper, (_f = classes) === null || _f === void 0 ? void 0 : _f.containerInput])}>
      {inputLabel !== false && <GenericInputLabel_1.GenericInputLabel label={label} id={id} required={required} tooltip={tooltip}/>}
      <TextField_1.default data-test={"text_input:" + id} id={id} type={type} variant={'outlined'} className={styles.input} placeholder={(placeholder !== null && placeholder !== void 0 ? placeholder : "" + label + (displayRequiredInPlaceholder ? ' *' : ''))} value={(value !== null && value !== void 0 ? value : '')} error={!!currentError} onChange={onChange} helperText={currentError && (<core_1.Typography component={'span'} className={styles.errorText} data-test={"text_input:error:" + id}>
              {currentError}
            </core_1.Typography>)} InputProps={{
        classes: {
            root: styles.root,
            focused: styles.focused,
            error: styles.inputError,
            notchedOutline: styles.notchedOutline,
            input: (_g = classes) === null || _g === void 0 ? void 0 : _g.input,
        },
        endAdornment: (<core_1.InputAdornment position="end">
              {datePicker && (<core_1.IconButton onClick={function () { return toggleDatePicker(true); }} component="span" className={styles.dateCalendar}>
                  <DateRange_1.default fontSize="small"/>
                </core_1.IconButton>)}
            </core_1.InputAdornment>),
        startAdornment: (<core_1.InputAdornment position="start">
              {phoneWithPrefix ? (<core_1.Box className={styles.phonePrefix}>
                  <Translation_1.default id={'enquiryForm.phonePrefix.label'}/>
                </core_1.Box>) : startAdornment ? (<core_1.IconButton className={(_h = classes) === null || _h === void 0 ? void 0 : _h.inputAdornmentIcon} component="span">
                  {startAdornment}
                </core_1.IconButton>) : ('')}
            </core_1.InputAdornment>),
    }} FormHelperTextProps={{
        classes: {
            root: clsx_1.default([styles.helperTextError, (_j = classes) === null || _j === void 0 ? void 0 : _j.helperTextError]),
        },
    }} {...(_k = params) === null || _k === void 0 ? void 0 : _k.inputProps}/>
    </div>);
};
exports.default = exports.GenericInput;
